module.exports = __webpack_public_path__ + "static/media/hindiA.a479918f.webp";